export default __webpack_public_path__ + "/src/assets/images/ic-modal-close-default.svg";